export default function SingleFilledStar({ className }) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.8374 0.958935C11.6477 0.395277 11.1137 0.0145507 10.5118 0.013761C9.90988 0.0129712 9.37506 0.392295 9.18407 0.955453L7.12578 7.02454L0.969501 9.04042C0.398256 9.22746 0.0124849 9.75429 0.0118033 10.3481C0.0111216 10.942 0.395682 11.4698 0.966496 11.6584L7.11813 13.6904L9.16248 19.7648C9.35217 20.3286 9.88613 20.7092 10.488 20.71C11.09 20.7108 11.6248 20.3315 11.8158 19.7683L13.8741 13.6993L20.0303 11.6834C20.6016 11.4963 20.9874 10.9695 20.988 10.3757C20.9887 9.78181 20.6042 9.25397 20.0333 9.06543L13.8818 7.0334L11.8374 0.958935Z"
        fill="#FACA20"
      />
    </svg>
  );
}
